import { ReactNode, useContext, useEffect, useState } from "react";
import { ConfirmContext } from "../contexts/ConfirmContextProvider";

export const useConfirm = () => {
    const [confirm, setConfirm] = useContext(ConfirmContext);
    const [needsCleanup, setNeedsCleanup] = useState<boolean>(false);

    const isConfirmed = (prompt: string, content?: ReactNode) => {
        setNeedsCleanup(true);

        const promise = new Promise((resolve, reject) => {
            setConfirm({
                prompt,
                isOpen: true,
                proceed: resolve as () => void,
                cancel: reject,
                content
            });
        });
        return promise.then(
            () => {
                setConfirm({ ...confirm, isOpen: false });
                return true;
            },
            () => {
                setConfirm({ ...confirm, isOpen: false });
                return false;
            }
        );
    };

    useEffect(() => {
        return () => {
            if (confirm.cancel && needsCleanup) {
                confirm.cancel();
            }
        };
    }, [confirm, needsCleanup]);

    return {
        ...confirm,
        isConfirmed
    };
};
